import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IStatisticsStore, User,
} from '../../mobx-store/storeInterfaces/statisticsInterface';

interface IProps {
  history: any;
  statisticsStore: IStatisticsStore;
}

interface IState {
  pageNumber: number;
  totalNumberOfPages: number;
  pageSize: number;
}

@inject('statisticsStore')
@observer
class UsersManagement extends Component<IProps, IState> {
  addButton: any;
  tabsLabels: string[] = [translate('UsersTableTabTitle', {}), translate('NotRegisteredUsersTabTitle', {})];
  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      pageNumber: 1,
      totalNumberOfPages: 1,
      pageSize: 50,
    };
  }

  async componentWillMount () {
    await this.props.statisticsStore.getAllUsers(this.state.pageNumber, this.state.pageSize, true);
    const numberOfPages = Math.ceil (
      this.props.statisticsStore!.numberOfUsers / this.state.pageSize
    );
    await this.setState({totalNumberOfPages: numberOfPages});
  }
  asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => {
    return new Promise((res) => {
      this.setState({
        ...state,
      }, () => res());
    });
  }
  getStatisticsTableHeader = () => {
    return [
      {
        title: translate(`statisticsListNameColumnTitle`, {}),
      },
      {
        title: translate(`statisticsListMemberShipColumnTitle`, {}),
      },
      {
        title: 'Role',
      },
      {
        title: 'Change Password',
      },
    ];
  }
getStatisticsTableData = () => {
  return this.props.statisticsStore!.adminsList
    .map((user: User) => {
      const userData = {
        firstName: user.firstName,
        membershipId: user.membershipId,
        userId: user.userId,
        phoneNumber: user.phoneNumber,
        title: user.title,
        changePassword: 'Change Password',
      };
      return userData;
    });
}
  getStatisticsTableCellTypes = (): TableCellTypes[] =>  {
    return  [
      {
        cellType: 'Text',
        key: 'firstName',
      },
      {
        cellType: 'Text',
        key: 'membershipId',
      },
      {
        cellType: 'Text',
        key: 'title',
      },
      {
        cellType: 'Button',
        key: 'changePassword',
        onClick: this.handleChangePasswordButtonCellClicked
      },
    ];
  }
  leftArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber - 1,
    });
    await this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, true);
  }

  rightArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber + 1,
    });
    await this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, true);
  }
  handleAdd = (): void => {
    this.props.history.push('/users/new');
  };
  getAddUsersButton = () => ({
    title: 'Add',
    onAdd: this.handleAdd,
  });

  handleSearchChanged = (title: any) => {
      this.props.statisticsStore!.getAllUsers(this.state.pageNumber, this.state.pageSize, true, title);
  }

  handleChangePasswordButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/users/${this.props.statisticsStore.adminsList[index].userId}/changePassword`);
  }

  render () {
    this.addButton = this.getAddUsersButton();
    this.tableHeader = this.getStatisticsTableHeader();
    this.tableData = this.getStatisticsTableData();
    this.tableCellTypes = this.getStatisticsTableCellTypes();
        return(
            <div>
                <GeneralTableComponent emptyMessage={translate(`settingsListNoSettingsMessage`, {})}
                                      tableHeader={this.tableHeader}
                                      tableData={this.tableData}
                                      addButton={this.addButton}
                                      tableCellTypes={this.tableCellTypes}
                                      loading = { this.props.statisticsStore!.loading}
                                      hadPagination={true}
                                      paginationAction={{
                                          handleClickLeftArrow: this.leftArrowClicked,
                                          handleClickRightArrow: this.rightArrowClicked,
                                          pageNumber: this.state.pageNumber,
                                          totalNumberOfPages: this.state.totalNumberOfPages,
                                      }}
                  />
          </div>
        );
    }
}

export default UsersManagement;
